import { useSiteUser } from "./session";
import logoSvg from "./assets/SparkLogo.svg";
import { hardNavigate } from "./bundleBoundary";

/**
 * Fixed pill-shaped navigation bar shared between the landing page and
 * public marketing pages (e.g. /pricing).
 *
 * Nav anchor links always target the landing-page sections via "/#section"
 * so they work correctly from any public route.
 */
export function LandingNav() {
  const user = useSiteUser();

  return (
    <header className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-4xl">
      <nav className="flex items-center justify-between h-14 px-4 md:px-6 rounded-full bg-white/70 dark:bg-[#2D274B] backdrop-blur-xl border border-white/20 dark:border-white/10 shadow-lg shadow-black/5 dark:shadow-black/20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2">
          <img src={logoSvg} alt="Spark Logo" className="h-14" />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="/#features"
            className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors"
          >
            Features
          </a>
          <a
            href="/#how-it-works"
            className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors"
          >
            How It Works
          </a>
          <a
            href="/#enterprise"
            className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors"
          >
            Teams
          </a>
          <a
            href="/pricing"
            className="text-sm font-medium text-foreground/70 hover:text-foreground transition-colors"
          >
            Pricing
          </a>
        </div>

        {/* CTA */}
        <div className="flex items-center">
          {user ? (
            <button
              onClick={() => hardNavigate("/app")}
              className="px-5 py-2 rounded-full text-sm font-medium bg-primary/40 backdrop-blur-md border border-primary/30 text-foreground hover:bg-primary/60 transition-all duration-300 shadow-sm shadow-primary/70"
            >
              Go to Dashboard
            </button>
          ) : (
            <button
              onClick={() => hardNavigate("/auth/login")}
              className="px-5 py-2 rounded-full text-sm font-medium bg-[#9787F3]/40 dark:bg-white/10 backdrop-blur-md border border-[#9787F3]/30 dark:border-white/20 text-foreground hover:bg-[#9787F3]/60 dark:hover:bg-white/20 transition-all duration-300 shadow-sm shadow-[#9787F3]/70 dark:shadow-white/10"
            >
              Sign In
            </button>
          )}
        </div>
      </nav>
    </header>
  );
}
